'use client';

import { useEffect } from 'react';
import { useSession } from 'next-auth/react';

export function useAutoRefresh() {
  const { data: session, update } = useSession();
  useEffect(() => {
    if (!session?.expires || !session?.user.exp) {
      return undefined;
    }

    const expMs = session.user.exp * 1000;
    const refreshBeforeMs = 60 * 1000;

    const now = Date.now();
    const targetTime = expMs - refreshBeforeMs;

    let delay = targetTime - now;

    if (delay < 0) {
      console.log('[Session AutoRefresh] - Refresh overdue, refreshing now');
      delay = 0;
    }

    console.log('[Session AutoRefresh] - Scheduling refresh in', delay, 'ms');

    const timeout = setTimeout(async () => {
      console.log('[Session AutoRefresh] - Refreshing token now');
      await fetch('/api/auth/refresh', { method: 'POST' });
      await update();
    }, delay);

    return () => clearTimeout(timeout);
  }, [session, update]);
  return null;
}

export function SessionAutoRefresh() {
  useAutoRefresh();
  return null;
}
